var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalPolice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2531_194646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3333 41.9668L51.3333 54.9002L40 48.0668L28.6667 54.9002L31.6667 42.0002L21.6667 33.3668L34.8667 32.2335L40 20.0668L45.1333 32.2002L58.3333 33.3335L48.3333 41.9668ZM40 10.6335L63.3333 21.0002V36.6668C63.3333 51.7335 53.4 65.6335 40 69.7668C26.6 65.6335 16.6667 51.7335 16.6667 36.6668V21.0002L40 10.6335ZM40 3.3335L10 16.6668V36.6668C10 55.1668 22.8 72.4668 40 76.6668C57.2 72.4668 70 55.1668 70 36.6668V16.6668L40 3.3335Z",
    fill: "#C11500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2531_194646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalPolice);
export default __webpack_public_path__ + "static/media/local_police.3a2686befb61983243cfb2f894211b7b.svg";
export { ForwardRef as ReactComponent };